import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';

import { AuthGuard } from '@auth0/auth0-angular';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { PermissionGuard } from './permission.guard';
import { isEmbedded } from '../constants/embedded.regex';

@Injectable({ providedIn: 'root' })
export class EmbeddedGuard implements CanActivate {
  private readonly permissionGuard = inject(PermissionGuard);
  private readonly authGuard = inject(AuthGuard);

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean {
    const url = new URL(window.location.href);

    if (isEmbedded() && !!url.searchParams.has('token')) {
      return true;
    }

    return combineLatest([
      this.authGuard.canActivate(route, state),
      this.permissionGuard.canActivate(route, state),
    ]).pipe(
      filter(
        ([authResult, permissionResult]) =>
          authResult !== undefined && permissionResult !== undefined
      ),
      take(1),
      map(([authResult, permissionResult]) => {
        if (!authResult) {
          return authResult;
        }

        if (permissionResult !== true) {
          return permissionResult;
        }

        return true;
      })
    );
  }
}
